import { FeathersModel } from './feathersModel'

export class OaCoordinator extends FeathersModel {
  static serviceName = 'features/oa-coordinators'

  userId: number

  workerId: string
  workgroupId: number
  workgroupName: string

  firstName: string
  lastName: string

  get fullname() {
    return this.fullName()
  }

  fullName() {
    return `${this.lastName} ${this.firstName}`
  }
}
